import AutosizeInput from 'react-input-autosize';
import * as setup from 'setup';
import styled from 'styled-components';

export const TruckNameInput = styled(AutosizeInput as any)`
    max-width: 90%;
    & > input {
        background: transparent;
        border-radius: 5px;
        border: none;
        color: ${setup.colors.black};
        font-family: inherit;
        font-size: 18px;
        max-height: 25px;
        max-width: 100%;
        min-width: 30px;
        outline: none;
        padding: 5px;
        text-align: center;
        transition: 300ms ease-in-out;
        &:hover {
            background: ${setup.colors.primary};
            transition: 300ms ease-in-out;
        }
        &:hover::placeholder {
            transition: 300ms ease-in-out;
        }
        &:focus {
            background: ${setup.colors.primary};
        }
    }
`;